import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postDataAPI } from '../utils/fetchData';
import { useDispatch } from 'react-redux';
import { setErrorAlert, setSuccessAlert } from '../store/alert/alertSlice';

const GoogleCalendarCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        const error = searchParams.get('error');

        if (error) {
          dispatch(setErrorAlert(`Google authorization failed: ${error}`));
          navigate('/connectors/google');
          return;
        }

        if (!code || !state) {
          dispatch(setErrorAlert('Missing authorization parameters'));
          navigate('/connectors/google');
          return;
        }
        
        // Exchange code for access token
        const token = JSON.parse(localStorage.getItem('dizeeToken'));
        const response = await postDataAPI('user/connectors/googleCalendar/exchange-code', {
          code,
          state
        }, token);
        
        if (response.status === 200) {
          dispatch(setSuccessAlert('Google connected successfully! Calendar and Gmail are now available.'));
          navigate('/connectors/google');
        } else {
          throw new Error(response.data?.message || 'Failed to complete Google authentication');
        }

      } catch (err) {
        console.error('Error handling Google callback:', err);
        dispatch(setErrorAlert(err.message || 'Failed to complete Google authentication'));
        navigate('/connectors/google');
      }
    };

    handleCallback();
  }, [searchParams, navigate, dispatch]);

  // Show loading state while processing
  return (
    <div className="flex items-center justify-center min-h-screen bg-black">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white text-[14px]">Connecting Google...</p>
        <p className="text-white text-[11px] opacity-50 mt-2">Please wait</p>
      </div>
    </div>
  );
};

export default GoogleCalendarCallback;

